import { render, staticRenderFns } from "./LoginShareholder.vue?vue&type=template&id=75a7d91a&scoped=true&"
import script from "./LoginShareholder.vue?vue&type=script&lang=ts&"
export * from "./LoginShareholder.vue?vue&type=script&lang=ts&"
import style0 from "./LoginShareholder.vue?vue&type=style&index=0&id=75a7d91a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7d91a",
  null
  
)

export default component.exports